/**
 * @GENERATED from Figma node 3638:52286
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const WordDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M6.5 2.92v18.16c0 1.06.846 1.92 1.89 1.92h12.72c1.044 0 1.89-.86 1.89-1.92V6.053c0-.513-.202-1.005-.561-1.366L19.32 1.555A1.88 1.88 0 0 0 17.99 1h-9.6C7.347 1 6.5 1.86 6.5 2.92"
      clipRule="evenodd"
    />
    <path
      fill="#9D9C9B"
      fillRule="evenodd"
      d="M6.5 2.92v18.16c0 1.06.846 1.92 1.89 1.92h12.72c1.044 0 1.89-.86 1.89-1.92V6.053c0-.513-.202-1.005-.561-1.366L19.32 1.555A1.88 1.88 0 0 0 17.99 1h-9.6C7.347 1 6.5 1.86 6.5 2.92m1.203 18.16V2.92c0-.385.308-.698.688-.698h9.367v4.19a1.3 1.3 0 0 0 1.289 1.31h2.75V21.08a.693.693 0 0 1-.688.699H8.391a.693.693 0 0 1-.688-.699M21.797 6.5v-.446a.7.7 0 0 0-.204-.497L18.96 2.913v3.5c0 .048.038.087.086.087z"
      clipRule="evenodd"
    />
    <path
      fill="#6BB3EC"
      fillRule="evenodd"
      d="M15.094 10.023c0-.332.27-.601.601-.601h3.953a.602.602 0 1 1 0 1.203h-3.953a.6.6 0 0 1-.601-.602"
      clipRule="evenodd"
    />
    <path
      fill="#508FD6"
      fillRule="evenodd"
      d="M15.094 12.773c0-.332.27-.601.601-.601h3.953a.602.602 0 1 1 0 1.203h-3.953a.6.6 0 0 1-.601-.602"
      clipRule="evenodd"
    />
    <path
      fill="#3770C3"
      fillRule="evenodd"
      d="M15.094 15.523c0-.332.27-.601.601-.601h3.953a.602.602 0 1 1 0 1.203h-3.953a.6.6 0 0 1-.601-.602"
      clipRule="evenodd"
    />
    <path
      fill="#3770C3"
      d="M1 7.36c0-.57.462-1.032 1.031-1.032h10.313c.57 0 1.031.462 1.031 1.031v10.313c0 .57-.462 1.031-1.031 1.031H2.03c-.57 0-1.031-.462-1.031-1.031z"
    />
    <path
      fill="#fff"
      d="m4.755 15.796-1.349-6.89h1.17l.846 4.733 1.034-4.733h1.359l.991 4.813.87-4.813h1.146l-1.372 6.89H8.238l-1.128-5.15-1.119 5.15z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(WordDark);
export { ForwardRef as WordDark };
